let statuses = {
  'legacy': [''],
  'hidden': ['cancelled', 'held', 'pending'],
  'cancelled': [''],
  'held': ['cancelled', 'held', 'pending', 'confirmed'],
  'error': ['cancelled', 'held', 'pending', 'confirmed'],
  'pending': ['cancelled', 'held', 'confirmed'],
  'processing': ['cancelled'],
  'processed': ['cancelled', 'confirmed'],
  'confirmed': ['cancelled'],
  're-booked': ['']
}

let statusTags = {
  'hidden': 'info',
  'cancelled': 'danger',
  'held': 'warning',
  'error': 'danger',
  'pending': 'warning',
  'processing': 'warning',
  'processed': '',
  'confirmed': 'success',
  're-booked': ''
}

export function statusAllows (from, to) {
  return from in statuses ? statuses[from].includes(to) : false
}

export function statusTag (status) {
  return status in statusTags ? statusTags[status] : 'info'
}
